import type { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import type { FrameShape } from './types';
import { classes, styles } from './utils';

export interface FrameProps extends PropsWithChildren {
  className?: string;
  shape?: FrameShape;
}

export default function Frame({
  className,
  shape = 'single',
  children,
}: FrameProps) {
  return (
    <div
      style={styles.card}
      className={twMerge(classes.card, classes[shape], className)}>
      {children}
    </div>
  );
}
